import React, { useMemo } from 'react';
import { Layers } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

// Live Sort No → consolidated qty across every bundle entered so far.
export const SortConsolidatedTable = ({ bundles = [], documentQty = 0 }) => {
  const rows = useMemo(() => {
    const map = new Map();
    bundles.forEach((b) => (b.sort_entries || []).forEach((s) => {
      const r = map.get(s.sort_no) || { sort_no: s.sort_no, qty: 0, bundles: new Set() };
      r.qty += Number(s.actual_qty) || 0;
      r.bundles.add(b.bundle_barcode);
      map.set(s.sort_no, r);
    }));
    return [...map.values()];
  }, [bundles]);

  if (!rows.length) return null;
  const total = rows.reduce((a, r) => a + r.qty, 0);
  const diff = total - (Number(documentQty) || 0);

  return (
    <div className="mt-4 pt-4 border-t border-[#E5DFD0]" data-testid="sort-consolidated-section">
      <div className="flex items-center gap-2 mb-2">
        <Layers className="w-4 h-4 text-[#2D5F4F]" />
        <span className="text-sm font-semibold text-[#1A1F2E]">Sort No wise Consolidated Qty</span>
      </div>
      <div className="border border-[#E5DFD0] rounded-lg overflow-hidden">
        <Table data-testid="sort-consolidated-table">
          <TableHeader>
            <TableRow className="bg-[#F5F1E8] hover:bg-[#F5F1E8]">
              <TableHead className="font-semibold text-[#1A1F2E]">Sort No</TableHead>
              <TableHead className="font-semibold text-[#1A1F2E] text-center">Bundles</TableHead>
              <TableHead className="font-semibold text-[#1A1F2E] text-center">Consolidated Qty</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.sort_no} data-testid={`sort-consolidated-row-${r.sort_no}`}>
                <TableCell className="font-medium">{r.sort_no}</TableCell>
                <TableCell className="text-center">{r.bundles.size}</TableCell>
                <TableCell className="text-center font-semibold" data-testid={`sort-consolidated-qty-${r.sort_no}`}>{r.qty}</TableCell>
              </TableRow>
            ))}
            <TableRow className="bg-[#F5F1E8] hover:bg-[#F5F1E8]">
              <TableCell className="font-semibold">Total</TableCell>
              <TableCell />
              <TableCell className="text-center font-bold" data-testid="sort-consolidated-total">{total}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p className="text-xs mt-2 text-[#5A5F6E]" data-testid="sort-consolidated-vs-doc">
        Document Qty: <span className="font-semibold">{documentQty}</span>
        {' · '}
        <span className={diff === 0 ? 'text-green-700 font-semibold' : 'text-orange-600 font-semibold'}>
          {diff === 0 ? 'Matches' : diff > 0 ? `Excess ${diff}` : `Short ${-diff}`}
        </span>
      </p>
    </div>
  );
};
